const textfieldValidator = require('../../../../../components/textfield/textfield-validator')
const validator = require('../../../../../components/textfield/validator.min')
const snackCustomer = require('./customer-snack')
const textfieldHandler = require('../../../../../components/textfield/textfield-handler')
const scrim = require('../../../../../components/scrim/scrim')

let customerHtmlFc = null
let customerChatsFc = null

export function initChatsFc(chats) {
    customerChatsFc = chats
}

export function getChatsFc() {
    return customerChatsFc
}

export function initDataFc(htmlFc) {
    customerHtmlFc = htmlFc
}

export function getDataFc() {
    return customerHtmlFc
}

export function addBillingToShipping(detail, htmlFc) {
    // console.log(htmlFc.fullcontHTML)
    let bill_to_address = htmlFc.fullcontHTML.querySelector("#customer_form_bill_to_address").querySelector('input[type="text"]');
    let bill_to_apt = htmlFc.fullcontHTML.querySelector("#customer_form_bill_to_apt").querySelector('input[type="text"]');
    let bill_to_city = htmlFc.fullcontHTML.querySelector("#customer_form_bill_to_city").querySelector('input[type="text"]');
    let bill_to_state = htmlFc.fullcontHTML.querySelector("#customer_form_bill_to_state").querySelector('select');
    let bill_to_zip = htmlFc.fullcontHTML.querySelector("#customer_form_bill_to_zip").querySelector('input[type="text"]');
    let ship_to_address = htmlFc.fullcontHTML.querySelector("#customer_form_ship_to_address");
    let ship_to_apt = htmlFc.fullcontHTML.querySelector("#customer_form_ship_to_apt");
    let ship_to_city = htmlFc.fullcontHTML.querySelector("#customer_form_ship_to_city");
    let ship_to_state = htmlFc.fullcontHTML.querySelector("#customer_form_ship_to_state");
    let ship_to_zip = htmlFc.fullcontHTML.querySelector("#customer_form_ship_to_zip");
    let check = htmlFc.fullcontHTML.querySelector("#customer_form_check_shipping_address");
    let check_value = check.querySelector('input[type="checkbox"]').checked;

    if (check_value) {
        // Verificar si el campo de facturación no está vacío
        if (bill_to_address.value.trim().length > 0
            || bill_to_apt.value.trim().length > 0
            || bill_to_city.value.trim().length > 0
            || bill_to_state.value.trim().length > 0
            || bill_to_zip.value.trim().length > 0) {

            ship_to_address.querySelector('input[type   ="text"]').value = bill_to_address.value;
            ship_to_apt.querySelector('input[type       ="text"]').value = bill_to_apt.value;
            ship_to_city.querySelector('input[type      ="text"]').value = bill_to_city.value;
            ship_to_state.querySelector('select').value = bill_to_state.value;
            ship_to_zip.querySelector('input[type       ="text"]').value = bill_to_zip.value;
        }
    } else {
        ship_to_address.querySelector('input[type ="text"]').value = ship_to_address.querySelector('input[type="text"]').value;
        ship_to_apt.querySelector('input[type     ="text"]').value = ship_to_apt.querySelector('input[type="text"]').value;
        ship_to_city.querySelector('input[type    ="text"]').value = ship_to_city.querySelector('input[type="text"]').value;
        ship_to_state.querySelector('select').value = ship_to_state.querySelector('select').value;
        ship_to_zip.querySelector('input[type     ="text"]').value = ship_to_zip.querySelector('input[type="text"]').value;
    }
}

export async function checkEmailInput(htmlFc, FromButton = false) {

    let emailInput = htmlFc.fullcontHTML.querySelector('#customer_form_email input');

    // Crear un nuevo objeto detailInput, para que siempre tenga el evento correcto
    let detailInput = {};
    detailInput.ev = {};
    detailInput.ev.target = emailInput;

    let email = emailInput.value.trim();

    if (validator.isEmail(email)) {

        if (!await checkEmailDB(email, htmlFc)) {
            textfieldValidator.completed(detailInput.ev);
        } else {
            textfieldValidator.incomplete(detailInput.ev, 'Email already exists');
            //solo activa el shake cuando es desde el boton save or savefromdialog
            if (FromButton) {
                textfieldHandler.error(emailInput.parentElement);
            }

            return false;
        }

    } else {
        textfieldValidator.incomplete(detailInput.ev, 'Invalid email');
        //solo activa el shake cuando es desde el boton save or savefromdialog
        if (FromButton) {
            textfieldHandler.error(emailInput.parentElement);
        }

        return false;
    }

    return true;
}

async function checkEmailDB(email, htmlFc) {

    let objToSend = { username: email };

    // Si no está en modo agregar, se agrega el dbid, ya que se está editando un registro existente
    // y se va a verificar si el username ya existe en otro usuario
    if (!htmlFc.fullcontHTML.classList.contains('mode-add')) {
        let dbid = htmlFc.fullcontHTML.getAttribute("data-dbid");
        objToSend.dbid = dbid;
    }


    const infNewData = getFormData(objToSend);

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 30000);

    let options = {
        method: 'POST',
        body: infNewData,
        signal: controller.signal,
        credentials: 'same-origin'
    };

    try {
        const response = await fetch(`server/php/sql/checkUsername.php`, options);
        const result = await response.json();

        clearTimeout(timeout);

        if (result.code == 200) {
            return true;
        } else {
            return false;
        }

    } catch (error) {
        console.error('Error en checkEmailDB:', error);
        //esto para que se detenga el proceso si hay error
        return true;
    }
}

export function sendResetEmail(data, htmlFc) {
    let infNewData = null;
    //para saber si se enviara el correo para un nuevo usuario o para un usuario existente
    if (data.new_user) {
        infNewData = getFormData({ email: data.email, name: data.name, last_name: '', new_user: 1, type: 'password_reset', user_type: 'cliente' })
    } else {
        infNewData = getFormData({ email: data.email, name: data.name, last_name: '', type: 'password_reset', user_type: 'cliente' })
    }
    //object > FormData()
    const controller = new AbortController();
    const timeout = setTimeout(() => { controller.abort() }, 30000);

    let options = { method: 'POST', body: infNewData, signal: controller.signal, credentials: 'same-origin' };

    fetch(`server/php/send-emails/sendEmail.php`, options)
        .then(result => {
            return result.json()
        })
        .then((result) => {
            // esto es porque cuando se guarda se tiene un snack automatico, este snack se mostrara luego del principal
            let snack = document.getElementById('snack');
            if (snack.classList.contains("show")) {
                setTimeout(() => {
                    if (result.code != 200) {
                        snackCustomer.start({ act: 'show', id: 'errorSendEmail', addTitle: result.message });
                    } else {
                        snackCustomer.start({ act: 'show', id: 'emailWasSent' });
                    }
                }, 5500);

            } else {
                if (result.code != 200) {
                    snackCustomer.start({ act: 'show', id: 'errorSendEmail', addTitle: result.message });
                } else {
                    snackCustomer.start({ act: 'show', id: 'emailWasSent' });
                }
            }
        })
        .catch((error) => { // 
            console.log('result 3', 'ERRORRRRRRRR');
            throw error;
        })

}

function getFormData(object) {
    const formData = new FormData()
    Object.keys(object).forEach(key => formData.append(key, object[key]))
    return formData
}

export function sendEmailFromButton(htmlFc) {


    let emailInput = htmlFc.fullcontHTML.querySelector('#customer_form_email input');
    let email = emailInput.value.trim();
    let name = '';

    htmlFc.form.forEach(element => {
        if (element.name === 'name') {
            name = element.value;
        }
    });

    sendResetEmail({ email: email, name: name, last_name: "", new_user: false }, htmlFc);

}

export function showButtonResetPassword(htmlFc) {
    let resetButton = htmlFc.fullcontHTML.querySelector('.reset_password');
    resetButton.classList.remove('dn');
}

export function hideButtonResetPassword(htmlFc) {
    let resetButton = htmlFc.fullcontHTML.querySelector('.reset_password');
    resetButton.classList.add('dn');
}

export function printReport(detail, htmlFc) {
    let id = null;
    if (detail.dbid) {
        generateReport(detail.dbid, detail.entity, detail.reportName);
        return
    }

    const cont = htmlFc.fullcontHTML;
    if(cont){
        id = cont.getAttribute('data-dbid');
        generateReport(id, detail.entity, detail.reportName);
        return
    }

    generateReport(id, detail.entity, detail.reportName);
}

function generateReport(dbid, entity, reportName) {
    scrim.showLoading()
    const formData = new FormData();
    formData.append('id', dbid);
    formData.append('type', 'print');
    formData.append('entity', entity);
    formData.append('reportName', reportName);

    const isPdf = true;

    const controller = new AbortController();
    const timeout = setTimeout(() => { controller.abort() }, 30000);

    let options = {
        method: 'POST',
        body: formData,
        signal: controller.signal,
        credentials: 'same-origin'
    };

    fetch(`./server/php/report/report-pdf.php`, options)
        .then((response) => {
            clearTimeout(timeout);
            if (!response.ok) throw new Error("report-pdf");
            // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

            return response.blob();
        })
        .then((blob) => {
            if (isPdf) {
                // --- LÓGICA PARA PDF ---
                const pdfBlob = new Blob([blob], { type: "application/pdf" });
                const fileUrl = URL.createObjectURL(pdfBlob);
                const newTab = window.open(fileUrl, "_blank");

                if (newTab) {
                    scrim.hideLoading()
                    newTab.addEventListener('load', () => {
                        URL.revokeObjectURL(fileUrl);
                    }, { once: true });
                }
            } else {
                scrim.hideLoading()
                // --- LÓGICA PARA CSV ---
                // Se define el MIME type para CSV
                const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
                const fileUrl = URL.createObjectURL(csvBlob);

                // Creamos un enlace temporal en el DOM
                const tempLink = document.createElement("a");
                tempLink.href = fileUrl;

                // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
                tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
                tempLink.style.display = "none";

                document.body.appendChild(tempLink);
                tempLink.click(); // Disparamos la descarga

                // Limpiamos el DOM y liberamos la memoria
                document.body.removeChild(tempLink);
                URL.revokeObjectURL(fileUrl);
            }
        })

        .catch(error => {
            scrim.hideLoading()
            throw error;
        });
}
